<template>
  <div
    :style="
      `${show_border ? 'border: 1px solid black;' : ';'} height: ${
        local_clipart_measurement.styles.height
      }px; width: ${
        local_clipart_measurement.styles.width
      }px;position: relative`
    "
  >
    <div v-if="local_clipart_measurement && local_clipart_measurement.clipart">
      <vue-drag-resize
        :style="`border: 1px solid white`"
        :isDraggable="isDragUser"
        :isResizable="false"
        @dragging="onDragMainClipart"
        :w="local_clipart_measurement.clipart.width"
        :h="local_clipart_measurement.clipart.height"
        :x="local_clipart_measurement.clipart_styles.x"
        :y="local_clipart_measurement.clipart_styles.y"
        :z="998"
      >
        <show-image :src="local_clipart_measurement.clipart.clipart.file" alt="" />
      </vue-drag-resize>
    </div>

    <div class="drag-main">
      <vue-drag-resize
        :isDraggable="isDragUser"
        :isResizable="false"
        @dragging="onDragDropZone"
        :w="local_clipart_measurement.hollow_styles.width"
        :h="local_clipart_measurement.hollow_styles.height"
        :x="local_clipart_measurement.hollow_styles.x"
        :y="local_clipart_measurement.hollow_styles.y"
        :z="997"
        class="drag-drop-area"
      >
      </vue-drag-resize>
    </div>

    <div
      v-if="
        local_clipart_measurement &&
          local_clipart_measurement.multi_clipart &&
          local_clipart_measurement.num_images
      "
      class="secondary-clipart"
    >
      <vue-drag-resize
        v-for="(clip_obj, clip_index) in local_clipart_measurement.properties"
        :key="`CLIPARTMEASUREMENT${clip_index}`"
        :isDraggable="true"
        :isResizable="false"
        @dragging="onDraggingClipsObj($event, clip_index)"
        :w="local_clipart_measurement.multi_clipart.width"
        :h="local_clipart_measurement.multi_clipart.height"
        :x="clip_obj.x"
        :y="clip_obj.y"
        :z="999"
      >
        <show-image
          :src="local_clipart_measurement.multi_clipart.clipart.file"
          :alt="`DRAGCLIPART${clip_index}`"
        />
      </vue-drag-resize>
    </div>
  </div>
</template>

<script>
import ShowImage from '@/components/General/ShowImage';
export default {
  name: "show-clipart-measurement",
  components : {
    ShowImage
  },
  props: {
    clipart_measurement: {
      type: Object,
    },
    isDragUser: {
      type: Boolean,
      default: false,
    },
    show_border: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      local_clipart_measurement: this.clipart_measurement,
    };
  },
  methods: {
    onDraggingClipsObj(e, index) {
      this.local_clipart_measurement.properties[index].x = e.left;
      this.local_clipart_measurement.properties[index].y = e.top;
    },
    onDragDropZone(e) {
      this.local_clipart_measurement.hollow_styles.x = e.left;
      this.local_clipart_measurement.hollow_styles.y = e.top;
    },
    onDragMainClipart(e) {
      this.local_clipart_measurement.clipart_styles.x = e.left;
      this.local_clipart_measurement.clipart_styles.y = e.top;
    },
  },
  watch: {
    clipart_measurement: {
      handler: function(new_val) {
        this.local_clipart_measurement = new_val;
      },
      deep: true,
    },
    local_clipart_measurement : {
      handler: function(new_val){
        this.$emit('updated', new_val)
      },
      deep : true
    }
  },
};
</script>

<style scoped>
.drag-drop-area {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #000000;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
  border-radius: 8px;
}
</style>
